import React from 'react'
import Grid from '../grid/grid'
import { prettyAmount } from '../../utils/amount'
import { dateToString } from '../../utils/date'

const gainLossTextColor = (ratio) => {
  if (!Number.isFinite(ratio)) {
    return undefined;
  }
  const maxAbsPct = 10;
  const absPct = Math.min(Math.abs(ratio * 100), maxAbsPct);
  const t = absPct / maxAbsPct;
  const lightness = 85 - t * 25;
  const hue = ratio >= 0 ? 120 : 0;
  return `hsl(${hue}, 70%, ${lightness}%)`;
};

const formatGainLossPct = (ratio) => {
  if (!Number.isFinite(ratio)) {
    return '';
  }
  const pct = ratio * 100;
  const sign = pct > 0 ? '+' : '';
  return `${sign}${pct.toFixed(2)}%`;
};

const computeGainLossPct = (prediction, baseClose) => {
  if (!Number.isFinite(prediction) || !Number.isFinite(baseClose) || baseClose === 0) {
    return null;
  }
  return (prediction - baseClose) / baseClose;
};

const columns = [
  {
    name: 'name',
    header: '',
    minWidth: 230,
    defaultFlex: 1,
    textAlign: 'center'
  },
  {
    name: 'prediction',
    header: 'Prediction',
    minWidth: 150,
    defaultFlex: 1,
    headerAlign: 'center',
    textAlign: 'center',
    render: ({value}) => prettyAmount(value),
  },
  {
    name: 'gainLossPct',
    header: 'Gain/Loss',
    minWidth: 150,
    defaultFlex: 1,
    headerAlign: 'center',
    textAlign: 'center',
    render: ({value}) => {
      if (!Number.isFinite(value)) {
        return '';
      }
      const color = gainLossTextColor(value);
      return (
        <span style={{
          fontVariantNumeric: 'tabular-nums',
          color,
        }}>
          {formatGainLossPct(value)}
        </span>
      );
    },
  },
  {
    name: 'date',
    header: 'Prediction Date',
    minWidth: 200,
    defaultFlex: 1,
    headerAlign: 'center',
    textAlign: 'center',
    render: ({value}) => dateToString(value),
  },
];

const Predictions = ({
  predictions: {
    daily_prediction,
    daily_prediction_date,
    two_day_prediction,
    two_day_prediction_date,
    weekly_prediction,
    weekly_prediction_date,
    two_week_prediction,
    two_week_prediction_date,
    monthly_prediction,
    monthly_prediction_date,
    two_month_prediction,
    two_month_prediction_date,
    three_month_prediction,
    three_month_prediction_date,
    six_month_prediction,
    six_month_prediction_date,
    yearly_prediction,
    yearly_prediction_date,
  } = {},
  baseClose,
  baseCloseDate,
}) => {

  const dataSource = [
    {
      id: 1,
      name: 'Daily Prediction',
      prediction: daily_prediction,
      gainLossPct: computeGainLossPct(daily_prediction, baseClose),
      date: daily_prediction_date,
    },
    {
      id: 2,
      name: 'Two Day Prediction',
      prediction: two_day_prediction,
      gainLossPct: computeGainLossPct(two_day_prediction, baseClose),
      date: two_day_prediction_date,
    },
    {
      id: 3,
      name: 'Weekly Prediction',
      prediction: weekly_prediction,
      gainLossPct: computeGainLossPct(weekly_prediction, baseClose),
      date: weekly_prediction_date,
    },
    {
      id: 4,
      name: 'Two Week Prediction',
      prediction: two_week_prediction,
      gainLossPct: computeGainLossPct(two_week_prediction, baseClose),
      date: two_week_prediction_date,
    },
    {
      id: 5,
      name: 'Monthly Prediction',
      prediction: monthly_prediction,
      gainLossPct: computeGainLossPct(monthly_prediction, baseClose),
      date: monthly_prediction_date,
    },
    {
      id: 6,
      name: 'Two Month Prediction',
      prediction: two_month_prediction,
      gainLossPct: computeGainLossPct(two_month_prediction, baseClose),
      date: two_month_prediction_date,
    },
    {
      id: 7,
      name: 'Three Month Prediction',
      prediction: three_month_prediction,
      gainLossPct: computeGainLossPct(three_month_prediction, baseClose),
      date: three_month_prediction_date,
    },
    {
      id: 8,
      name: 'Six Month Prediction',
      prediction: six_month_prediction,
      gainLossPct: computeGainLossPct(six_month_prediction, baseClose),
      date: six_month_prediction_date,
    },
    {
      id: 9,
      name: 'Yearly Prediction',
      prediction: yearly_prediction,
      gainLossPct: computeGainLossPct(yearly_prediction, baseClose),
      date: yearly_prediction_date,
    },
  ].filter(item => item.prediction !== null && item.prediction !== undefined);
  
  return (
    <div className="homeGraphTable">
      {Number.isFinite(baseClose) && (
        <div style={{marginBottom: 10, textAlign: 'center'}}>
          Close (as of {dateToString(baseCloseDate)}): <b>{prettyAmount(baseClose)}</b>
        </div>
      )}
      <Grid
        idProperty="id"
        columns={columns}
        dataSource={dataSource}
        className="singleStockChartTable"
        autoHeight
        rowHeight={35}
        headerHeight={45}
      />
    </div>
  )
}

export default Predictions;
